var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.3 17.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #cb919a;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m15.29,16.13l-1.4-11.22c-.1-.81-.8-1.42-1.61-1.42h-.46c-.36-1.98-2.08-3.48-4.16-3.48S3.84,1.51,3.49,3.48h-.45c-.82,0-1.51.61-1.61,1.42L.01,16.13c-.06.46.08.93.39,1.28.31.35.75.55,1.22.55h12.05c.47,0,.91-.2,1.22-.55.31-.35.45-.82.39-1.28ZM7.65.94c1.56,0,2.86,1.09,3.2,2.55h-6.4c.34-1.46,1.64-2.55,3.2-2.55Zm6.12,15.47s-.05.04-.09.04H1.63s-.08-.02-.1-.04c-.02-.02-.04-.05-.03-.1l1.4-11.22c0-.06.06-.11.13-.11h9.24c.06,0,.12.05.13.11l1.4,11.22s-.01.08-.03.1Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.7e59b857e0719ca29804f0b319e4cefb.svg";
export { ForwardRef as ReactComponent };